import React from 'react'
import '../styles/Checkout.css'
function Checkout() {
  return (
    <div className='checkout--complete'>
        <h1>Thank you</h1>
        <p>Your order is now being processed</p>
    </div>
  )
}

export default Checkout